import {
  createAsyncThunk,
  createSlice,
} from "@reduxjs/toolkit";

import listCustomers from "../services/customers/listCustomers";

export const searchCustomers = createAsyncThunk(
  "customers/search",
  listCustomers.handler,
);

const initialState = {
  lists: [],
  loading: false,
  keyword: "",
  attribute: "email",
};

const slice = createSlice({
  name: "customers",
  initialState,
  reducers: {
    clearCustomers: (state) => {
      state.lists = [];
    },
    setCustomerSearch: (state, action) => {
      // { keyword?, attribute? } — only update what's provided
      if (action.payload.keyword !== undefined) state.keyword = action.payload.keyword;
      if (action.payload.attribute !== undefined) state.attribute = action.payload.attribute;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchCustomers.pending, listCustomers.pending)
      .addCase(searchCustomers.fulfilled, listCustomers.fulfilled)
      .addCase(searchCustomers.rejected, listCustomers.rejected);
  },
});

export const { clearCustomers, setCustomerSearch } = slice.actions;
export default slice.reducer;
